import effectManager from '../module/effect';
import TransitionManager from '../module/global/transition';

let effect = new effectManager();

/* ---------------------------------------

    -- ABOUT モーダル機能

--------------------------------------- */
export default class  aboutModalManager {
    constructor() {

        this.$root = $("#l-root");

        this.$logo =  $("#l-header-logo");
        this.$container = $(".p-lowlayer");
        this.$bg = $("#p-lowlayer-bg");
        this.$header = $("#p-lowlayer-header");

        this.$target = {
            "company" : $("#p-company"),
            "recruit" : $("#p-recruit"),
        }

        this.$trigger = $(".js__modal-trigger");
        this.$close = $(".p-lowlayer-close,.p-lowlayer-logo");

        this.$headerMovieBtn = $("#l-header-play");


        this.transition = new TransitionManager();

        this.status = {
            select : "",
            currentID : "", /* アクティブ状態のセンテンスのIDを保存 */
            // current : 0,
            // prevCurrent:0,
            // time : 0,
        }

        this.conf = {
            // NUM   : this.$target.length-1,
            // PAUSE : 240,
        }


    }
    init(){

        TweenMax.set(this.$container.find(".outline.type-x >*"),{
            x:-101+"%",
        })
        TweenMax.set(this.$container.find(".outline.type-y >*"),{
            y:-100+"%",
        })
        TweenMax.set(this.$container.find(".p-side"),{
            x:-101+"%",
        })

    }
    open($select,selectID){



        $select.addClass("is-active");
        this.$root.addClass("is-modal");
        TweenMax.set(this.$root,{height:$select.find(".p-lowlayer-content-body").innerHeight()});


        this.status.currentID = $(".p-section.is-current").attr("id");
        $("#"+this.status.currentID).removeClass("is-current");

        if(this.status.currentID==="p-vision") TweenMax.to(this.$logo.find(".st0"),0.3,{fill:"#000"});

        effect.cover(!Useragnt.mobile?this.$bg.find(".js__cover"):this.$bg.find(".js__cover-sp"),"show");
        effect.show(this.$headerMovieBtn,"out");

        setTimeout(()=>{

            TweenMax.to($select.find(".p-side"),0.4,{
                x:0+"%",
                ease:Power2.easeOut
            })

            this.transition.out("modal");

            effect.splitText($("#p-lowlayer-header-"+selectID).find(".js__splittext >* >*"),"show")
            effect.show($select.find(".js__show__inner"),"show");

            TweenMax.to($select.find(".outline.type-x >*"),0.4,{
                x:0+"%",
                ease:Power2.easeOut
            })
            TweenMax.to($select.find(".outline.type-y >*"),0.4,{
                y:0+"%",
                ease:Power2.easeOut
            })

            setTimeout(()=>this.$bg.addClass("is-active"),1e3);

        },5e2)


    }
    close($select,selectID){


        if(this.status.currentID==="p-vision") TweenMax.to(this.$logo.find(".st0"),0.3,{fill:"#fff"});

        effect.splitText($("#p-lowlayer-header-"+selectID).find(".js__splittext >* >*"),"out")
        effect.show($select.find(".js__show__inner"),"out");
        TweenMax.to($select.find(".p-side"),0.4,{
            x:-101+"%",
            ease:Power2.easeOut
        })


        TweenMax.to($select.find(".outline.type-x >*"),0.4,{
            x:-101+"%",
            ease:Power2.easeOut
        })
        TweenMax.to($select.find(".outline.type-y >*"),0.4,{
            y:-100+"%",
            ease:Power2.easeOut
        })

        setTimeout(()=>{
            this.$bg.removeClass("is-active")
            this.$root.removeClass("is-modal");
            TweenMax.set(this.$root,{height:window.innerHeight});
            TweenMax.set(window,{scrollTo:0});
            effect.cover(!Useragnt.mobile?this.$bg.find(".js__cover"):this.$bg.find(".js__cover-sp"),"out");
            this.transition.show("modal");
            effect.show(this.$headerMovieBtn,"show");
            setTimeout(()=>$select.removeClass("is-active"),5e2);

        },5e2);

        $("#"+this.status.currentID).addClass("is-current");
        // setTimeout(()=>this.$bg.removeClass("is-active"),1e3);

    }

    render(){
    }
    resize(){

    }
}